document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict(),
		d = new Date(),
		n = d.getFullYear(),
		page = $('html, body');

		$('.foo-copy s').text(n).addClass('foo-copy-year');

	function onScroll() {

		if ($(window).scrollTop() > 70) {
			$('.scroll-up').removeClass('hidden');
			$('.site-header').addClass('static');
		} else {
			$('.scroll-up').addClass('hidden');
			$('.site-header').removeClass('static');
		}
	}
	window.addEventListener('scroll', onScroll, false);

	$('.page-template-page-machine-selector .wp-block-query--machines ul li').each(function() {
		var wrap_url = $(this).children('a').attr('href');
		$(this).addClass('faux-link__element').append('<a href=' + wrap_url + ' class="faux-link__overlay-link machine-wrap" /></a>');
	});

	$('body:not(.page-template-page-machine-selector) .wp-block-query--machines ul li').each(function() {
		var wrap_url = $(this).children('h3').find('a').attr('href');
		$(this).addClass('faux-link__element').append('<a href=' + wrap_url + ' class="faux-link__overlay-link machine-wrap" /></a>');
	});

	$('.wp-block-navigation__responsive-container-open').html('<i></i><i></i><i></i>');

	$('body.single .wp-block-post-featured-image').addClass('img-left');

	$('.wpc-filters-button-text, .wpc-widget-popup-title').text('Filter by');

	$('.wp-block-query ul li').first().children('.wp-block-read-more').text('READ FULL BLOG');

	$('.wpc-filters-button-text, .wpc-widget-popup-title').text('Filter by');

	//$('body.home').addClass('intro-video__body');

	$('body.home .intro-video').removeClass('hide hidden');

	$('#close-menu-body').on('click', function(){
		//$('.has-modal-open.close').click();
		history.go(0);
	});

	$('.accordion-button').addClass('collapsed');

	$('.wpcf7-select').select2({
		placeholder: "Please select",
		minimumResultsForSearch: 3,
    	allowClear: true
	});

	$('.wpc-dropdown-default').text('Any');

	$(".foo-copy .widget_text p strong").text(n);

	$('.h-icons .search-h').on( "click", function() {
		$('.h-icons .wp-block-search').toggleClass('active');
	});

	$('.h-icons .soc-h').on( "click", function() {
		$('.h-icons .wp-block-social-links').toggleClass('active');
	});

	$('.scroll-up').click(function(e) {
		page.animate({
			scrollTop : 0,
		}, 100);
		e.preventDefault();
	});

	$('.scroll-down').click(function(e) {
		var SlideHeight = $('.section__home-hero').height();
		// /console.log(SlideHeight);
		page.animate({
			scrollTop : page.scrollTop() + SlideHeight,
		}, 1000);
		e.preventDefault();
	});

	$('.open-popup-link').magnificPopup({
		markup: '<div class="mfp-iframe-scaler">'+
				'<div class="mfp-close"></div>'+
				'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
			'</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
		tLoading: 'Loading...',
		type:'inline',
		midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
	});

	var single_m_img = $('.single-machines--gallery .wp-block-post-featured-image img').attr('src');
	$('.single-machines--gallery .wp-block-post-featured-image img').wrapAll('<a href="' + single_m_img + '" class="fancybox"></a>');

	$('.machine-gallery__items--item img').click(function() {
		var img_url = $(this).attr('src');
		//console.log(img_url);
		$(this).parents().find('.wp-block-post-featured-image a.fancybox').attr('href',img_url);
		$(this).parents().find('.wp-block-post-featured-image img').attr('src',img_url).attr('srcset',img_url);
	});

	$('.tag-model-article').each(function() {
		let $subject = $(this);
		let title = $($subject).text();
		let $row = $($subject).closest('.row');
		let $button = $($row).find('.stock-enquiry-button');
		let href = $($button).attr('href');
		$($button).attr('href', href + '?subject=' + title);
	});

	$('.wpcf7-acceptance .wpcf7-list-item').append('<i></i>');

	$('.accordion-item:first-child .accordion-button').click();

	const acc_first_url = $('.accordion-item').first().attr('data_image');
	$('.box-image').css('background-image', 'url('+acc_first_url+')');

	$('.accordion-item').click(function() {
        if($(this).data('clicked', true)){
			const url = $(this).attr('data_image');
			$('.box-image').css('background-image', 'url('+url+')');
        } 
    });

	// /*********************************************
	// ** FLOATING LABELS FOR CF7
	// *********************************************/
	$("input, textarea").on('focus',function() { 
		$(this).parent().siblings("label").addClass("move");
	});
	$("select, input.hasDatepicker").on('change', function() { 
		$(this).parent().siblings("label").addClass("move");
	});
	$("input, textarea").blur(function() { 
		if ($(this).val().length == 0) {
			$(this).parent().siblings("label").removeClass("move");
		}
	});

	var labelID; 
	$('label').on('click',function () {
		labelID = $(this).attr('for');
		$('#' + labelID).trigger('click');
	});

	//In case there is a prefill value
	$("input, textarea").on('each',function() {
		if ($(this).val().length != 0) { 
			$(this).parent().siblings("label").addClass("move");
		} 
		else {
			$(this).parent().siblings("label").removeClass("move");
		}
	});

	var machine_name = $('body.single-machines h1.wp-block-post-title').text();
	$('input[name=your-subject]').val(machine_name);

	$(".subjected input.wpcf7-form-control").prop('readonly', true);

	if($('.subjected input.wpcf7-form-control').val() != '') {
		$(".subjected input.wpcf7-form-control").focus();
		$(".subjected input.wpcf7-form-control").blur();
		
	}

});
